import React, { useState } from 'react';
import { Modal } from './Modal';
import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsOfService } from './TermsOfService';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-[#5C4A3A] py-8 text-center" data-id="element-3">
        <div className="max-w-4xl mx-auto px-4" data-id="element-4">
          <p className="text-[#FBF8F3]/40 text-xs mb-3" data-id="element-5">
            © {new Date().getFullYear()} Transforma tu Vida. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center justify-center gap-4 text-xs" data-id="element-6">
            <button onClick={() => setShowPrivacy(true)} className="text-[#FBF8F3]/60 hover:text-[#E8A87C] transition-colors underline underline-offset-2" data-id="element-7">
              Política de Privacidad
            </button>
            <span className="text-[#FBF8F3]/30" data-id="element-8">•</span>
            <button onClick={() => setShowTerms(true)} className="text-[#FBF8F3]/60 hover:text-[#E8A87C] transition-colors underline underline-offset-2" data-id="element-9">
              Términos de Servicio
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-10">
        <PrivacyPolicy data-id="element-11" />
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos de Servicio" data-id="element-12">
        <TermsOfService data-id="element-13" />
      </Modal>
    </>;
}